import React from 'react';
import { CircleDotIcon, LayersIcon } from 'lucide-react';
import { Section } from './Shared';
import { KanjiBackdrop } from './Ornaments';
import { painPoints } from '../data/painPoints';
const therapistImageUrl = 'https://cdn.magicpatterns.com/patterns/generated-images/257d66df-d752-427d-9cf8-2d38b32d3e47.jpg';
export function PainPoints() {
  return <Section className="max-w-5xl" data-id="element-181" data-mp="2bvfxbs1ngcd8">
      <KanjiBackdrop glyphs={['學', '習', '道', '探', '索']} data-id="element-182" data-mp="1xxzsum2wyso4" />
      <div className="grid items-center gap-8 md:grid-cols-[1.15fr_1fr] md:gap-12" data-id="element-183" data-mp="1xwgc6udciflt">
        <div className="text-center md:text-left" data-id="element-184" data-mp="220wcmg46wutn">
          <p className="text-xl text-amber-700/70" aria-hidden="true" data-id="element-185" data-mp="1nztps15dfgho">
            問
          </p>
          <h2 className="mt-2 text-3xl font-bold leading-tight tracking-tight text-stone-900 md:text-[2.75rem]" data-id="element-186" data-mp="1syeotx8vzu4j">
            ¿Sentís que todavía hay mucho por explorar en Medicina China?
          </h2>
          <div className="mt-6 space-y-4 text-sm leading-relaxed text-stone-700 md:text-base" data-id="element-187" data-mp="3nd7l7yhlgoxj">
            <p data-id="element-188" data-mp="1z0f1v1h87i9j">
              La Medicina China es amplia. Incluye distintas ramas, tradiciones y
              maneras de estudiar el cuerpo y sus relaciones. Aun con formación
              previa, siempre aparecen conceptos para revisar y conexiones nuevas
              por descubrir.
            </p>
            <p className="text-stone-500" data-id="element-189" data-mp="23qvewkh4x1vd">
              Cuando el material está repartido entre libros, apuntes y fuentes
              distintas, puede costar encontrar una secuencia de estudio o volver
              rápidamente sobre un tema.
            </p>
            <p className="font-semibold text-emerald-700" data-id="element-190" data-mp="1b4supbov0oei">
              El KIT MEDICINA TRADICIONAL CHINA™ reúne contenidos de varias áreas
              en una biblioteca visual organizada para acompañar tu formación
              continua.
            </p>
          </div>
        </div>
        <img src={therapistImageUrl} alt="Terapeuta estudiando con libros y fichas de Medicina China en su consultorio" loading="lazy" decoding="async" className="aspect-[4/3] w-full rounded-2xl border border-stone-200 object-cover shadow-md" data-id="element-191" data-mp="30ftau60mf5u4" />
      </div>
      <div className="mt-10 rounded-xl border border-red-200 bg-white p-5 shadow-sm md:p-7" data-id="element-192" data-mp="1y3glclmyncfr">
        <h3 className="flex items-center gap-2 text-base font-bold uppercase tracking-[0.06em] text-stone-900 md:text-lg" data-id="element-193" data-mp="225bn1r8szru2">
          <LayersIcon className="h-5 w-5 shrink-0 text-red-700" aria-hidden="true" data-id="element-194" data-mp="273muxwfjfs9n" />
          Lo que puede pasar cuando tus fuentes están dispersas
        </h3>
        <span className="mt-3 block h-px w-full bg-stone-200" aria-hidden="true" data-id="element-195" data-mp="1efzdurdh7jrr" />
        <ul className="mt-5 grid gap-3 sm:grid-cols-2 md:gap-x-6 md:gap-y-4" data-id="element-196" data-mp="1edwc5a2yo277">
          {painPoints.map(point => <li key={point} className="flex gap-2.5 text-[13px] leading-snug text-stone-700 md:text-sm" data-id="element-197" data-mp="1o623qipawhlv">
              <CircleDotIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-red-700" aria-hidden="true" data-id="element-198" data-mp="qqocp8s7rnd3" />
              <span data-id="element-199" data-mp="vphnuuk132a3">{point}</span>
            </li>)}
        </ul>
      </div>
      <p className="mx-auto mt-10 max-w-3xl text-center text-2xl font-bold italic tracking-tight text-red-700 md:text-3xl" data-id="element-200" data-mp="vnoeh7i163ye">
        No se trata de empezar de cero. Se trata de seguir formándote con una
        biblioteca amplia, organizada y fácil de recorrer.
      </p>
    </Section>;
}